import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import bgImg from '../Images/contact-us.webp'
import Breadcrumb from "../Components/Breadcrumb";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt
} from "react-icons/fa";
import { treatments } from "../Data";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useRecaptcha } from "../Components/Recaptcha";
import ContactPageSchema from "../Schema/ContactPageSchema";
import MedicalClinicSchema from "../Schema/MedicalClinicSchema";
import BreadcrumbSchema from "../Schema/BreadcrumbSchema";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import sendMetaEvent from "../Utils/metaTracking";

const Contact=()=>{
    useEffect(() => {
            document.title =
              "Contact Dr. Jigar Gor for Ayurvedic Treatment in Bhuj";
        
            const metaDesc = document.querySelector("meta[name='description']");
            if (metaDesc) {
              metaDesc.setAttribute(
                "content",
                "Contact us for the best Ayurvedic treatment for Panchkarma, Garbh Sanskar, Shirodhara & Mental Wellness by Dr. Jigar Gor at our top hospital in Bhuj Kutch."
              );
            }
        
           const canonical = document.querySelector("link[rel='canonical']");
          if (canonical) {
            canonical.setAttribute("href", "https://msayurved.com/contact-us");
          }
        
          const ogTitle = document.querySelector("meta[property='og:title']");
          if (ogTitle) {
            ogTitle.setAttribute(
              "content",
              "Contact Dr. Jigar Gor for Ayurvedic Treatment in Bhuj"
            );
          }
        
            const ogDesc = document.querySelector("meta[property='og:description']");
          if (ogDesc) {
            ogDesc.setAttribute(
              "content",
              "Contact us for the best Ayurvedic treatment for Panchkarma, Garbh Sanskar, Shirodhara & Mental Wellness by Dr. Jigar Gor at our top hospital in Bhuj Kutch."
            );
          }
        
          const ogUrl = document.querySelector("meta[property='og:url']");
          if (ogUrl) {
            ogUrl.setAttribute("content", "https://msayurved.com/contact-us");
          }
        
            const ogImage = document.querySelector("meta[property='og:image']");
          if (ogImage) {
            ogImage.setAttribute(
              "content",
              "https://msayurved.com/Images/contact-us.webp"
            );
          }
        
            const twitterTitle = document.querySelector("meta[name='twitter:title']");
          if (twitterTitle) {
            twitterTitle.setAttribute(
              "content",
              "Contact Dr. Jigar Gor for Ayurvedic Treatment in Bhuj"
            );
          }
        
            const twitterDesc = document.querySelector(
            "meta[name='twitter:description']"
          );
          if (twitterDesc) {
            twitterDesc.setAttribute(
              "content",
              "Contact us for the best Ayurvedic treatment for Panchkarma, Garbh Sanskar, Shirodhara & Mental Wellness by Dr. Jigar Gor at our top hospital in Bhuj Kutch."
            );
          }
        
           const twitterImage = document.querySelector("meta[name='twitter:image']");
          if (twitterImage) {
            twitterImage.setAttribute(
              "content",
              "https://msayurved.com/Images/contact-us.webp"
            );
          }
          }, []);

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const generateToken = useRecaptcha();


const [formData, setFormData] = useState({
  fullName: "",
  email: "",
  phoneNumber: "",
  treatment: "",
  message: "",
});

const handleChange = (e) => {
  const { name, value, files } = e.target;

  setFormData((prev) => ({
    ...prev,
    [name]: files ? files[0] : value,
  }));
};

const handleSubmit = async (e) => {
  e.preventDefault();

  if (!formData.fullName)
    return toast.error(
      "Please enter your full name"
    );

  if (!formData.email)
    return toast.error(
      "Please enter email address"
    );

  if (!formData.phoneNumber)
    return toast.error(
      "Please enter phone number"
    );

  if (!formData.message)
    return toast.error(
      "Please enter your health concerns"
    );

const phoneDigits = formData.phoneNumber.replace(/\D/g, "");

if (phoneDigits.length < 10) {
  return toast.error(
    "Please enter a valid phone number"
  );
}

  setLoading(true);
  generateToken(async (token) => {

  try {
    const recaptchaData = new FormData();

      recaptchaData.append(
        "secret",
        "6Lf_Qb4tAAAAAA35Wmjx9ZuK_6_NmESyX4-fAe3p"
      );

      recaptchaData.append(
        "response",
        token
      );

      const verifyRes = await axios.post(
        "https://api.sendmail.adhyaynam.in/recaptcha-verify",
        recaptchaData,
        {
          headers: {
            "Content-Type":
              "multipart/form-data",
          },
        }
      );

      const score =
        verifyRes.data.score ||
        verifyRes.data.data?.score;

      if (!score || score <= 0.5) {

        toast.error(
          "Spam detected. Please try again."
        );

        setLoading(false);

        return;
      }

    const template = `
<div style="
  margin:0;
  padding:40px 0;
  background:#F6F4EF;
  font-family:Georgia,'Times New Roman',serif;
">

<table width="100%" cellpadding="0" cellspacing="0">
<tr>
<td align="center">

<table
width="720"
cellpadding="0"
cellspacing="0"
style="
background:#ffffff;
border-radius:24px;
overflow:hidden;
box-shadow:0 15px 50px rgba(0,0,0,0.08);
"
>

<!-- GOLDEN TOP BAR -->

<tr>
<td
style="
height:10px;
background:#C49A5A;
"
>
</td>
</tr>

<!-- HEADER -->

<tr>
<td
style="
background:#1E3A2F;
padding:50px 40px;
text-align:center;
"
>

<!-- LOGO AREA -->


<img
src='https://msayurved.com/Images/white-logo.svg'
alt='Dr. Jigar Gor Ayurveda'
style='max-width:180px;margin-bottom:20px;'
/>


<div
style="
color:#C49A5A;
font-size:14px;
letter-spacing:4px;
text-transform:uppercase;
margin-bottom:12px;
"
>
Ayurvedic Wellness Centre
</div>

<h1
style="
margin:0;
color:#ffffff;
font-size:34px;
font-weight:700;
line-height:1.3;
"
>
New Contact Enquiry
</h1>

<p
style="
margin-top:18px;
color:#D8DFD5;
font-size:15px;
line-height:1.8;
"
>
A patient has submitted a new contact Enqiury through the website.
</p>

</td>
</tr>

<!-- CONTENT -->

<tr>
<td style="padding:45px;">

<h2
style="
margin:0 0 20px;
color:#271F12;
font-size:24px;
border-bottom:2px solid #C49A5A;
padding-bottom:10px;
"
>
Patient Information
</h2>

<table
width="100%"
cellpadding="0"
cellspacing="0"
style="
border:1px solid #E8E3D8;
border-radius:18px;
overflow:hidden;
"
>

<tr>
<td
style="
padding:18px 24px;
border-bottom:1px solid #E8E3D8;
"
>
<span style="color:#8B8374;">
Full Name
</span><br/>
<strong style="color:#271F12;">
${formData.fullName}
</strong>
</td>
</tr>

<tr>
<td
style="
padding:18px 24px;
border-bottom:1px solid #E8E3D8;
"
>
<span style="color:#8B8374;">
Email Address
</span><br/>
<strong style="color:#271F12;">
${formData.email}
</strong>
</td>
</tr>

<tr>
<td
style="
padding:18px 24px;
border-bottom:1px solid #E8E3D8;
"
>
<span style="color:#8B8374;">
Phone Number
</span><br/>
<strong style="color:#271F12;">
${formData.phoneNumber}
</strong>
</td>
</tr>

<tr>
<td
style="
padding:18px 24px;
border-bottom:1px solid #E8E3D8;
"
>
<span style="color:#8B8374;">
Treatment
</span><br/>
<strong style="color:#1E3A2F;">
${formData.treatment || "Not specified"}
</strong>
</td>
</tr>


</table>

<!-- MESSAGE -->

<div style="margin-top:35px;">

<h2
style="
margin-bottom:15px;
color:#271F12;
font-size:24px;
"
>
Health Concerns
</h2>

<div
style="
background:#FAFAF8;
border:1px solid #E8E3D8;
padding:25px;
border-radius:16px;
line-height:2;
color:#3B2E1B;
"
>
${formData.message}
</div>

</div>

</td>
</tr>

<!-- FOOTER -->

<tr>
<td
style="
background:#1E3A2F;
padding:35px;
text-align:center;
"
>

<div
style="
color:#C49A5A;
font-size:18px;
font-weight:700;
margin-bottom:8px;
"
>
Dr. Jigar Gor Ayurveda Clinic
</div>

<p
style="
margin:0;
color:#D8DFD5;
font-size:13px;
line-height:1.8;
"
>
Bhuj, Kutch, Gujarat<br/>
Traditional Ayurveda • Panchkarma • Holistic Wellness
</p>

</td>
</tr>

</table>

</td>
</tr>
</table>

</div>
`;

    const data = new FormData();

    data.append(
      "title",
      "Dr Jigar Gor Appointment Form"
    );

    data.append(
      "to_email",
      "dr.jigargor@yahoo.com"
    );

    data.append(
      "cc",
      "arkayappsseo@gmail.com,sales@arkayapps.com"
    );

    data.append(
      "subject",
      "New Contact Enquiry"
    );

    data.append(
      "template",
      template
    );

    await axios.post(
      "https://api.sendmail.adhyaynam.in/send-mail/two",
      data,
      {
        headers: {
          "Content-Type":
            "multipart/form-data",
        },
      }
    );

    const whatsappData = {
  fullName: formData.fullName,
  email: formData.email,
  phoneNumber: formData.phoneNumber,
  treatment: formData.treatment,
};

await axios.post(
  "/.netlify/functions/contact-us",
  whatsappData,
  {
    headers: {
      "Content-Type": "application/json",
    },
  }
);

const patientContactData = {
  name: formData.fullName,
  phoneNumber: formData.phoneNumber,
};

await axios.post(
  "/.netlify/functions/patient-contact-us",
  patientContactData,
  {
    headers: {
      "Content-Type": "application/json",
    },
  }
);


    toast.success(
      "Message sent successfully. We will contact you shortly."
    );

    setFormData({
      fullName: "",
      email: "",
      phoneNumber: "",
      message: "",
    });
    sessionStorage.setItem("trackThankYouLead", "true");
    navigate("/thank-you");

  } catch (error) {

    toast.error(
      "Something went wrong. Please try again."
    );

  } finally {

    setLoading(false);

  }
  });

};

const breadcrumbItems = [
    {
      name: "Home",
      url: "https://msayurved.com/"
    },
    {
      name: "Contact Dr. Jigar Gor",
      url: "https://msayurved.com/contact-us"
    },
  ];
    return(
        <>

      <ContactPageSchema />
  <MedicalClinicSchema />
  <BreadcrumbSchema items={breadcrumbItems} />

<ToastContainer
  position="top-right"
  autoClose={3000}
/>
        {/**BREADCRUMB SECTION */}
        <Breadcrumb
        title="Contact us"
        bgImage={bgImg}
        />

        {/**FORM SECTION */}
<section className="contact-section container">

  {/* LEFT FORM */}

  <motion.div
    className="contact-form-wrapper"
    initial={{
      opacity: 0,
      x: -40,
    }}
    whileInView={{
      opacity: 1,
      x: 0,
    }}
    viewport={{
      once: true,
      amount: 0.2,
    }}
    transition={{
      duration: 1,
      ease: "easeOut",
    }}
  >
    <motion.h2
      className="section-heading"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8 }}
    >
      Send us a Message
    </motion.h2>

    <motion.p
      className="section-text"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8, delay: 0.1 }}
    >
      Fill out the form below and we'll get back to you as soon as possible.
    </motion.p>

    <form className="contact-form" onSubmit={handleSubmit}>

      <motion.div
        className="form-group"
        initial={{ opacity: 0, y: 15 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ delay: 0.15, duration: 0.5 }}
      >
        <label>Full Name *</label>
        <input
          type="text"
  name="fullName"
  value={formData.fullName}
  onChange={handleChange}
  placeholder="Enter your Full Name"
        />
      </motion.div>

      <motion.div
        className="form-group"
        initial={{ opacity: 0, y: 15 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ delay: 0.2, duration: 0.5 }}
      >
        <label>Email Address *</label>
        <input
           type="email"
  name="email"
  value={formData.email}
  onChange={handleChange}
  placeholder="Enter Email Address"
        />
      </motion.div>

     <motion.div
  className="form-group phone-form-group"
  initial={{ opacity: 0, y: 15 }}
  whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true }}
  transition={{ delay: 0.25, duration: 0.5 }}
>
  <label>Phone Number *</label>

  <PhoneInput
    country="in"
    value={formData.phoneNumber}
    onChange={(phone) =>
      setFormData((prev) => ({
        ...prev,
        phoneNumber: phone,
      }))
    }
    enableSearch
    searchPlaceholder="Search country"
    countryCodeEditable={false}
    placeholder="Enter your Contact Number"
    inputProps={{
      name: "phoneNumber",
      required: true,
    }}
  />
</motion.div>

      <motion.div
        className="form-group"
        initial={{ opacity: 0, y: 15 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ delay: 0.3, duration: 0.5 }}
      >
        <label>Treatment</label>

        <select
        name="treatment"
  value={formData.treatment}
  onChange={handleChange}>
          <option value="">
    Select the Treatment you are looking for
  </option>
          {treatments.map((item, i) => (
    <option
      key={i}
      value={item.title}
    >
      {item.title}
    </option>
  ))}
        </select>
      </motion.div>

      <motion.div
        className="form-group full-width"
        initial={{ opacity: 0, y: 15 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ delay: 0.35, duration: 0.5 }}
      >
        <label>Message *</label>

        <textarea
          rows="5"
  name="message"
  value={formData.message}
  onChange={handleChange}
  placeholder="Enter your Message"
        />
      </motion.div>

      <motion.div
        className="submit-wrap"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ delay: 0.45 }}
      >
       <motion.button
  type="submit"
  className="nav-btn"
  disabled={loading}
  whileHover={{
    scale: 1.03,
    y: -2,
  }}
  whileTap={{
    scale: 0.98,
  }}
>
  {loading
    ? "Sending..."
    : "Send Message"}
</motion.button>
      </motion.div>

    </form>
  </motion.div>

  {/* RIGHT INFO */}

  <motion.div
    className="contact-info"
    initial={{
      opacity: 0,
      x: 40,
    }}
    whileInView={{
      opacity: 1,
      x: 0,
    }}
    viewport={{
      once: true,
      amount: 0.2,
    }}
    transition={{
      duration: 1,
      ease: "easeOut",
    }}
  >
    <h2 className="section-heading">
      Contact Information
    </h2>

    <p className="section-text">
      Whether you need to schedule a consultation,
      have a question about our treatments, or need
      ongoing patient support, please reach out.
      Our medical team will get back to you as soon
      as possible.
    </p>

    <div className="contact-divider"></div>

    <div className="contact-info-list">

      {[1, 2, 3].map((_, index) => (
        <motion.div
          key={index}
          className="contact-info-item"
          initial={{
            opacity: 0,
            y: 20,
          }}
          whileInView={{
            opacity: 1,
            y: 0,
          }}
          viewport={{
            once: true,
          }}
          transition={{
            delay: index * 0.15,
            duration: 0.6,
          }}
        >
          {index === 0 && (
            <>
              <div className="contact-icon">
                <FaPhoneAlt />
              </div>

              <div>
                <h3 className="card-heading">
                  Phone
                </h3>

                <a
                  href="tel:+919099094847"
               onClick={() => sendMetaEvent("PhoneClick")}
                  className="section-text"
                >
                  +91 90990 94847
                </a>
              </div>
            </>
          )}

          {index === 1 && (
            <>
              <div className="contact-icon">
                <FaEnvelope />
              </div>

              <div>
                <h3 className="card-heading">
                  Email
                </h3>

                <a
                  href="mailto:dr.jigargor@yahoo.com"
                  className="section-text"
                >
                  dr.jigargor@yahoo.com
                </a>
              </div>
            </>
          )}

          {index === 2 && (
            <>
              <div className="contact-icon">
                <FaMapMarkerAlt />
              </div>

              <div>
                <h3 className="card-heading">
                  Address
                </h3>

                <p className="section-text">
                  Narayan Complex, Near Lohana Samaj Wadi,
                  Madhapar - Tal. Bhuj-Kutch,
                  Gujarat - 370020
                </p>
              </div>
            </>
          )}
        </motion.div>
      ))}

    </div>
  </motion.div>

</section>

{/* MAP */}

<motion.section
  className="contact-map-section"
  initial={{
    opacity: 0,
    y: 40,
  }}
  whileInView={{
    opacity: 1,
    y: 0,
  }}
  viewport={{
    once: true,
    amount: 0.2,
  }}
  transition={{
    duration: 1,
    ease: "easeOut",
  }}
>
    <div className="container">

  <iframe
    title="Clinic Location"
   src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3666.1197928738698!2d69.7049829757188!3d23.23872747902289!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3950e1985591400b%3A0xa8884bd7e6e66dc7!2sDr.Jigar%20Gor%20&#39;s%20Ayurveda%20Clinic%20Bhuj!5e0!3m2!1sen!2sin!4v1780477756976!5m2!1sen!2sin" 
    loading="lazy"
    allowFullScreen
  ></iframe>
</div>

</motion.section>
        </>
    )
}
export default Contact;